import Vue from 'vue'

// as a plugin
import { InlineSvgPlugin } from 'vue-inline-svg'
Vue.use(InlineSvgPlugin)
